import type { ContactDraft } from '../bookingFlow';

interface Props {
  contact: ContactDraft;
  comments: string;
  onContact: (patch: Partial<ContactDraft>) => void;
  onComments: (value: string) => void;
}

const fieldClass =
  'mt-1.5 w-full rounded-lg border border-charcoal/20 bg-white px-4 py-2.5 font-sans text-sm text-charcoal placeholder:text-charcoal/35 focus:border-crimson focus:outline-none focus:ring-1 focus:ring-crimson';
const labelClass =
  'font-sans text-[0.62rem] font-semibold uppercase tracking-label text-charcoal/55';

export function ContactStep({ contact, comments, onContact, onComments }: Props) {
  return (
    <div>
      <h3 className="font-display text-2xl font-medium text-charcoal">
        Your details
      </h3>
      <p className="mt-1.5 font-sans text-sm font-light text-stone">
        We&rsquo;ll send your confirmation here and use it to coordinate the shoot.
      </p>

      {/* A real <form> with named fields so browsers reliably offer contact
          autofill (Safari/Chrome won't autofill standalone inputs). The wizard
          drives navigation from the footer, so submit is a no-op here. */}
      <form
        className="mt-6 flex flex-col gap-4"
        autoComplete="on"
        onSubmit={(e) => e.preventDefault()}
      >
        <label className="block">
          <span className={labelClass}>Full name</span>
          <input
            type="text"
            name="name"
            autoComplete="name"
            value={contact.fullName}
            onChange={(e) => onContact({ fullName: e.target.value })}
            placeholder="Jane Doe"
            className={fieldClass}
          />
        </label>

        <div className="grid gap-4 sm:grid-cols-2">
          <label className="block">
            <span className={labelClass}>Email</span>
            <input
              type="email"
              name="email"
              autoComplete="email"
              inputMode="email"
              value={contact.email}
              onChange={(e) => onContact({ email: e.target.value })}
              placeholder="jane@example.com"
              className={fieldClass}
            />
          </label>
          <label className="block">
            <span className={labelClass}>Phone / WhatsApp</span>
            <input
              type="tel"
              name="tel"
              autoComplete="tel"
              inputMode="tel"
              value={contact.phone}
              onChange={(e) => onContact({ phone: e.target.value })}
              placeholder="+30 698 570 7174"
              className={fieldClass}
            />
          </label>
        </div>

        <label className="block">
          <span className={labelClass}>Special requests &amp; add-ons (optional)</span>
          <textarea
            rows={3}
            name="comments"
            autoComplete="off"
            value={comments}
            onChange={(e) => onComments(e.target.value)}
            placeholder="Preferred time of day, flying dress add-on, flowers, anything else…"
            className={`${fieldClass} resize-none`}
          />
        </label>
      </form>
    </div>
  );
}
